import React, { useState } from 'react';

// Event type options
const EVENT_TYPES = [
  { value: '', label: 'Select an event type' }, // Added default option
  { value: 'wedding', label: 'Wedding' },
  { value: 'birthday', label: 'Birthday' },
  { value: 'shower', label: 'Baby Shower' },
  { value: 'life_celebration', label: 'Life Celebration' },
  { value: 'home_decor', label: 'Home Decor' },
  { value: 'other', label: 'Other' },
];

// Character limit constant
const MAX_STORY_LENGTH = 100;

function TestiEvent({ data }) {
  const dataValues = data.data || data;

  // Check if event_type is valid
  const isValidEventType = type => {
    return type && EVENT_TYPES.some(option => option.value === type && option.value !== '');
  };

  // Initialize event type from received data, defaulting to empty string if not valid
  const [eventType, setEventType] = useState(
    isValidEventType(dataValues.event_type) ? dataValues.event_type : ''
  );
  const [storyText, setStoryText] = useState('');

  const countCharsExcludingSpaces = text => {
    return text.replace(/\s+/g, '').length;
  };

  // Handler for text changes
  const handleStoryChange = e => {
    const newText = e.target.value;
    if (countCharsExcludingSpaces(newText) <= MAX_STORY_LENGTH) {
      setStoryText(newText);
    } else {
      e.preventDefault();
    }
  };

  // Handler for event type changes
  const handleEventTypeChange = e => {
    setEventType(e.target.value);
  };

  // Calculate current character count (excluding spaces)
  const currentChars = countCharsExcludingSpaces(storyText);

  return (
    <div className="testi-event-container">
      <h2 className="sywfh_r_subtitle">About Your Event</h2>

      {/* Event Type Selection */}
      <fieldset className="testi-field-group width-25">
        <div className="testi-header-field">
          <label className="testi-header-label" htmlFor="eventType">
            <span className="testi-label-text">
              <b>Event Type</b>
            </span>
          </label>

          <div className="testi-header-select-wrapper">
            <select
              name="eventType"
              className="testi-header-select"
              aria-label="Event Type"
              id="eventType"
              value={eventType}
              onChange={handleEventTypeChange}>
              {EVENT_TYPES.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
            <span className="testi-header-select-icon" aria-hidden="true"></span>
          </div>
        </div>
      </fieldset>

      {/* Story Text Area */}
      <fieldset className="testi-field-group" style={{ marginTop: '2%' }}>
        <label className="form-label fs-body-base" htmlFor="storyBody">
          Share your event story! Tell us how your flowers brought your celebration to life or added
          a touch of magic.
        </label>

        <div className="textarea-container" style={{ position: 'relative' }}>
          <textarea
            id="storyBody"
            name="storyBody"
            className="form-input form-input-placeholder textareaStory input"
            placeholder="Tell us about your special day"
            value={storyText}
            onChange={handleStoryChange}
            aria-describedby="storyCharCount"></textarea>

          <div
            id="storyCharCount"
            className="char-counter"
            style={{
              position: 'absolute',
              bottom: '8px',
              right: '10px',
              fontSize: '16px',
              color: currentChars > MAX_STORY_LENGTH - 20 ? '#d32f2f' : '#666',
              background: 'rgba(255, 255, 255, 0.8)',
              padding: '2px 4px',
              borderRadius: '2px',
            }}
            aria-live="polite">
            {currentChars}/{MAX_STORY_LENGTH}
          </div>
        </div>
      </fieldset>
    </div>
  );
}

export { TestiEvent };
